// extracted by mini-css-extract-plugin
export default {"note":"note-_bBo","button":"button-KHYL"};